<template>
  <div class="home">
    <div class="banner">
      <div class="left-con">
        <div v-if="lang == 'en'">
          <h1 class="tit" v-html="homeData.banner.tit"></h1>
          <p class="con">{{ homeData.banner.con }}</p>
        </div>
        <div v-else>
          <h1 class="tit" v-html="homeData.banner.tit1"></h1>
          <p class="con" v-html="homeData.banner.con1 "></p>
          <p class="con"> <img class="icon" src="../assets/imgs/hk.svg" alt />{{homeData.banner.con2}}</p>
          <h2 class="tit2" v-html="homeData.banner.tit2"></h2>
        </div>
        <div @click="goRegister()" class="btn">{{ homeData.banner.btn }}</div>
      </div>
      <div class="right-pic">
        <img src="../assets/imgs/hero-human-animated.gif" alt />
      </div>
    </div>
    <!-- welcome -->
    <div class="welcome">
      <div v-if="lang == 'en'">
        <h1 class="tit">{{ welcomeData.tit }}</h1>
        <p class="con">{{ welcomeData.con }}</p>
      </div>
      <div v-else>
        <h1 class="tit">{{ welcomeData.tit1 }}</h1>
        <h1 class="tit tit1">{{ welcomeData.tit2 }}</h1>
        <p class="con1">{{ welcomeData.con1 }}</p>
        <h4 class="con">{{ welcomeData.con2 }}</h4>
      </div>
      <!-- 上部内容 -->
      <h4 v-if="lang == 'cn'" class="txt"> {{ welcomeData.txt1 }}</h4>
      <div class="welcome-top-container">
        <div class="welcome-item-left">
          <div
            @click="changeImg(index)"
            class="left-item"
            :class="welcomeData.selectItem === index ? 'active' : ''"
            v-for="(item, index) in welcomeData.leftItem"
            :key="index"
          >
            <img class="item-logo" :src="require('../assets/imgs/Icons/' + item.logo)" />
            <p class="con">{{ lang == 'en'? item.con : item.con1}}</p>
          </div>
        </div>
        <div class="welcome-item-right">
          <h1 class="tit">{{lang =='en' ? welcomeData.leftItem[welcomeData.selectItem].con :welcomeData.leftItem[welcomeData.selectItem].con1}}</h1>
          <div class="img-container">
            <ul ref="welcome_list_box" class="list-box">
              <li ref="welcome_img_item" class="img-item" v-for="(item, index) in welcomeData.leftItem" :key="index">
                <img  :src="require('../assets/imgs/' + (lang == 'en' ? item.img_src : item.src))" />
              </li>
            </ul>
          </div>
          <div class="dots"></div>
        </div>
      </div>
      <h4 v-if="lang == 'cn'" class="txt"> {{ welcomeData.txt2 }}</h4>
      <!-- 底部内容 -->
      <div class="welcome-bottom-container" v-if="lang == 'en'">
        <div class="bottom-item" v-for="(item, index) in welcomeData.bottomItem" :key="index">
          <img class="item-logo" :src="require('../assets/imgs/Icons/' + item.logo)" alt />
          <p class="tit">{{ item.tit }}</p>
          <p class="con">{{ item.con }}</p>
        </div>
        <!-- 轮播图 -->
        <swiper :options="swiperOption" class="swiper-wrap" ref="mySwiper">
          <swiper-slide v-for="(item, index) in welcomeData.bottomItem" :key="index">
            <img class="item-logo" :src="require('../assets/imgs/Icons/' + item.logo)" alt />
            <p class="tit">{{ item.tit }}</p>
            <p class="con">{{ item.con }}</p>
          </swiper-slide>
          <!-- 小圆点 -->
          <div
            class="swiper-pagination"
            v-for="(item, index) in welcomeData.bottomItem"
            :key="index"
            slot="pagination"
          ></div>
        </swiper>
      </div>
    </div>
    <!-- automation -->
    <div class="automation">
      <h1 class="tit" v-html="lang == 'en'? automation.tit : automation.tit1"></h1>
      <p class="con"  v-html="lang == 'en'? automation.con : ''"></p>
      <!-- 切换widi状态 -->
      <div class="changeType">
        <span :class="{ active: widiType === false }">
          {{
            lang == 'en'? homeData.automation.firstTypeText : homeData.automation.firstTypeText1
          }}
        </span>
        <div class="changeType-btn">
          <label for="toggle">
            <input ref="iosbtn" @click="changeWidi()" type="checkbox" id="toggle" />
            <span></span>
          </label>
        </div>
        <span :class="{ active: widiType === true }">
          {{
            lang == 'en'? homeData.automation.secondTypeText : homeData.automation.secondTypeText1
          }}
        </span>
      </div>
      <!-- widi工作流程 -->
      <div class="automation-widi-container">
        <!-- 左部 -->
        <div class="automation-widi-item left-item-container">
          <img
            v-for="item in automation.leftItem"
            :key="item"
            :src="require('../assets/imgs/' + item)"
          />
        </div>
        <!-- 中部 -->
        <div class="automation-widi-item mid-item-container">
          <img src="../assets/imgs/Icons/bracket-1x.png" alt />
          <img :src="require('../assets/imgs/' + widiTypeImg)" alt />
          <img src="../assets/imgs/Icons/arrow-1x.png" alt />
        </div>
        <!-- 右部 -->
        <div class="automation-widi-item right-item-container">
          <div v-for="(item, index) in automation.rightItem" :key="index" class="right-item">
            <div class="img-item">
              <img
                :class="{ widiImg: widiType }"
                :src="
                  require('../assets/imgs/' +
                    (widiType ? item.widiImgPath : item.typicalImgPath))
                "
              />
            </div>
            <div class="content" v-if="lang == 'en'">
              <p class="tit">{{ item.tit }}</p>
              <p class="con">{{ widiType ? item.widiCon : item.con }}</p>
            </div>
            <div class="content" v-else>
              <p class="tit">{{ widiType? item.tit1: item.tit2 }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部提示 -->
    <div class="bottom-bg">
      <p class="bottom-tit" v-html="lang == 'en' ? bottomData.tit:bottomData.tit1"></p>
      <p class="bottom-tip" v-if="lang == 'en'">{{bottomData.con}}<br>{{bottomData.con1}}</p>
      <p class="bottom-tip" v-else>{{bottomData.con2}}</p>
      <div class="bottom-banner">
        <div class="dots"></div>
        <div :class="index === 0 ? 'left-part' : 'right-part'" v-for="(item, index) in tokenList" :key="index">
          <p class="tips">{{ item.name }}</p>
          <p class="con">{{ lang == 'en'? item.tip :item.tip1 }}</p>
          <p class="tit" v-if="lang =='en'"><span class="dollar">$</span>{{ item.price }}</p>
          <p class="free" v-if="lang == 'cn' && index ===0">{{ item.price1 }}</p>
          <div v-if=" lang == 'cn' &&index === 1">
            <div class="sale">限時優惠</div>
            <div class="sale1"></div>
            <div class="line"></div>
            <div class="price">
              <span class="dollar price1">${{ item.price }}</span>
              <span class="dollar">$</span>{{ item.price1 }}
            </div>
          </div>
          <p class="con">{{ lang == 'en'? item.con :item.con1 }}</p>
          <div @click="goRegister()" class="btn">{{ item.btn }}</div>
          <p>{{ lang =='en'? item.detail_tit:item.detail_tit1 }}</p>
          <div v-if="lang =='en'" >
            <div class="detail-tank" v-for="name in item.details" :key="name">
            <i class="el-icon-check" />
            <p class="detail">{{name}}</p>
            </div>
          </div>
          <div v-else >
            <div class="detail-tank" v-for="name in item.details1" :key="name">
            <i class="el-icon-check" />
            <p class="detail">{{name}}</p>
            </div>
          </div>
        </div>
      </div>
      <p class="sign-tip" v-if="lang =='en'">Still on the fence? You can still try WIDI with a free token. <span class="signup" @click="goRegister()">Sign up</span></p>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { swiper, swiperSlide } from "vue-awesome-swiper";
require("swiper/dist/css/swiper.css");
export default {
  name: "Home",
  data() {
    return {
      lang: window.localStorage.getItem('locale'),
      screenWidth: document.body.clientWidth,
      lgHomeData: {
        banner: {
          tit: "WIDI redefines<br /> the role of auditors",
          tit1: "出多一份report，就賺多一份錢拚速度 。 唯快不破",
          con:
            "WIDI is a cloud-based audit engagement software that brings the team together and all of your work in one place so you can get the audit done anytime, anywhere.",
          con1:'WIDI 幫你在10分鐘內完成一份審計報告，<br />無論身處何時何地，你都可以體驗不一樣的賺錢速度。',
          con2:'全力支援香港中小型會計師事務所',
          tit2:'你的行家已經使用WIDI。你，還等什麼？',
          btn: "TRY WIDI FOR FREE"
        },
        automation: {
          firstTypeText: "Typical Workflow",
          firstTypeText1: "傳統會計師樓",
          secondTypeText: "Widi Workflow",
          secondTypeText1: "WIDI會計師樓"
        }
      },
      xsHomeData: {
        banner: {
          tit: "WIDI redefines the role of auditors",
          tit1: "出多一份report，就賺多一份錢拚速度 。 唯快不破",
          con:
            "WIDI is a cloud-based audit engagement software that brings the team together and all of your work in one place so you can get the audit done anytime, anywhere.",
          con1:'WIDI 幫你在10分鐘內完成一份審計報告，<br />無論身處何時何地，你都可以體驗不一樣的賺錢速度。',
          con2:'全力支援香港中小型會計師事務所',
          tit2:'你的行家已經使用WIDI。你，還等什麼？',
          btn: "TRY WIDI FOR FREE"
        },
        automation: {
          firstTypeText: "Typical",
          firstTypeText1: "傳統",
          secondTypeText: "Widi",
          secondTypeText: "Widi",

        }
      },
      welcomeData: {
        tit: "Welcome to the future of auditing",
        tit1:"介面易用，簡單清晰", 
        tit2:"任何人都可以編制出一份完美report", 
        con:
          "Digitalisation is the new norm and every one should be equipped with a wiser tool.",
        con1:"WIDI的 report自動生成功能，讓你只需要幾個按鍵就能夠編制一份完整audit report",
        con2:"從今天起，擺脫時間拘束",
        txt1:"WIDI幫到你：",
        txt2:"還有更多。。。。",
        leftItem: [
          {
            logo: "icon-dashboard-1x.png",
            con: "Monitor active engagements",
            con1:"整spreadsheet",
            img_src: "welcome1.jpg",
            src: "hk1.png"
          },
          {
            logo: "icon-file-dollar-1x.png",
            con: "Create financial statements",
            con1:"過adjustment",
            img_src: "welcome2.jpg",
            src: "hk2.png",
          },
          {
            logo: "icon-file-check-1x.png",
            con: "Make audit assessments",
            con1:"Roll forward上年",
            img_src: "welcome3.jpg",
            src: "hk3.png",
          },
          {
            logo: "icon-edit-1x.png",
            con: "Edit, send, and sign documents",
            con1:"Revise TB 自動update",
            img_src: "welcome4.jpg",
            src: "hk4.png",
          },
          {
            logo: "icon-search-dollar-1x.png",
            con: "Review audit procedures",
            con1:"出report",
            img_src: "welcome5.jpg",
            src: "hk5.png",
          },
          {
            logo: "icon-user-tie-1x.png",
            con: "Collaborate with your team",
            con1:"出信",
            img_src: "welcome6.jpg",
            src: "hk6.png",
          }
        ],
        // 当前选中的welcome项
        selectItem: 0,
        bottomItem: [
          {
            logo: "icon-cloud-1x.png",
            tit: "Cloud based",
            con:
              "Get all the benefits of a paperless audit system that you can access anytime anywhere in the world."
          },
          {
            logo: "icon-diagram-1x.png",
            tit: "Workflow Management",
            con:
              "Streamline audit plan, fieldworks andreview with intuitive built-in workflowsfor preparers and reviewers."
          },
          {
            logo: "icon-robot-1x.png",
            tit: "Automation",
            con:
              "Repetitive, time-consuming tasks are reduced. WIDI helps you save time so that you can focus on what matters."
          },
          {
            logo: "icon-edit-1x.png",
            tit: "Template based Audits",
            con:
              "Have the ability to clone partial or entire audits so you create new or recurring ones in just a few clicks."
          },
          {
            logo: "icon-checklist-1x.png",
            tit: "Compliance",
            con:
              "Fufilling Compliance systematically regarding risk assessment, audit issue identification and etc."
          },
          {
            logo: "icon-lock-1x.png",
            tit: "Data Security",
            con:
              "Our two-factor authentication and encryption keeps your data safe, secured and private."
          }
        ]
      },
      automation: {
        tit: "Say hello to automation and goodbye to tedious tasks",
        tit1:"擺脫舊有模式<br/>擁抱科技革新",
        con: "Do more in less time",
        leftItem: [
          "Icons/xero-1x.png",
          "Icons/qb-1x.png",
          "Icons/excel-2x.png"
        ],
        rightItem: [
          {
            typicalImgPath: "Icons/word-1x.png",
            widiImgPath: "widi-logo-xs.png",
            tit: "Clearance, Engagement and Confirmation Letters",
            con: "Preparation is done manually.",
            tit1:"無需typing, casting, cross referencing; 沒有OT的人生可以更精彩",
            tit2: "永續typing、casting、cross referencing;OT是為了重複修改又修改",
            widiCon: "Preparation can be done in a few clicks."
          },
          {
            typicalImgPath: "Icons/excel-1x.png",
            widiImgPath: "widi-logo-xs.png",
            tit: "Trial Balance Mapping",
            con: "vlookup, Ctrl+C, Ctrl+V, repeat.",
            tit1:"每一次改數，WIDI都會幫你從頭到尾update一次，真正一鍵處理",
            tit2:"改一個數，所有working paper由頭tie一次，審計無間地獄",
            widiCon: "No more vlookup, Ctrl+C and Ctrl+V."
          },
          {
            typicalImgPath: "Icons/excel-1x.png",
            widiImgPath: "widi-logo-xs.png",
            tit: "Program Breakdown",
            con:
              "Spend hours even with advanced Excel skills and keyboard shortcuts.",
            tit1:"沒有臃腫的 checklist,我們只做應該做的事",
            tit2:"一堆無意義的checklist要填，無限個方格但大部分都是填NA",
            widiCon: "You can start your valuable work task in no time."
          },
          {
            typicalImgPath: "Icons/word-1x.png",
            widiImgPath: "widi-logo-xs.png",
            tit: "FS Report",
            con:
              "Sometimes you may need to work overnight to catch the deadlines.",
            tit1:"極速為客戶編制report。給他一個驚喜，明年也會記得你",
            tit2:"客户不斷抱怨為什麼總是delay，明年不再找你",
            widiCon: "Drafting wizard would save you from working overnight."
          }
        ]
      },
      bottomData:{
        tit:'Choose the best price for you',
        con:'No signup fees. No long term commitment.',
        con1:'Just pay-as-you-go. All prices are in USD.',
        tit1:'以前無，但係將來會有<br/>選擇真正幫到你賺錢既工具',
        con2:'無登記費，無年費一鍵登記，即可使用',
      },
      tokenList:[
        {
          name: 'WIDI Lite',
          tip: 'All the basic features you need to start auditing.',
          tip1: '最強出account 工具。10分鐘幫你出report',
          price: "10",
          price1: "免費",
          con: "Per token or audit engagement",
          con1: "無使用次數限制",
          btn: "START FOR FREE",
          detail_tit: 'Everything you get in Lite:',
          detail_tit1: 'WIDI Lite給你以下功能：',
          details:[
            'Lead schedule preparation',
            'Financial data mapping',
            'Financial report production',
            'Practice management',
            // 'Up to 50 users',
            '1 TB cloud storage'
          ],
          details1:[
            '整spreadsheet',
            '過adjustment',
            '自動 roll forward',
            '自動update TB',
            '出report',
            '出信'
          ]
        },
        {
          name: 'WIDI Standard',
          tip: 'For advanced auditors who want more automations and tools.',
          tip1: '如果你想要一套完整audit workflow',
          price: "30",
          price1: "10",
          con: "Per token or audit engagement",
          con1:"按每一個audit engagement 收費",
          btn: "START FOR FREE",
          detail_tit: 'Everything in Lite, plus:',
          detail_tit1: '除WIDI Lite的功能外，再加上：',
          details: [
            'Document preparation (Eng letter, Rep letter, etc)',
            'Audit workflow management (Planning, Program,Completion)',
            // 'Up to 1000 users',
            '9 TB cloud storage'
          ],
          details1: [
            '完整audit workflow，包括planning，fieldwork，completion 等',
            '項目管理工具，如進度追蹤，audit queries 等',
            '審計知識應用資料庫',
          ]
        }
      ],
      // 轮播图配置
      swiperOption: {
        //循环
        loop: true,
        //设定初始化时slide的索引
        initialSlide: 0,
        //滑动速度
        speed: 800,
        //滑动方向
        direction: "horizontal",
        //小手掌抓取滑动
        grabCursor: true,
        //分页器设置
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          type: "bullets"
        }
      },
      // widi状态
      widiType: false,
      // 当前widi状态的图片
      widiTypeImg: "process-human-animated.gif",
      welcome_timer: null
    };
  },
  components: {
    swiper,
    swiperSlide
  },
  methods: {
    // 切换widi状态图
    changeWidi() {
      this.$nextTick(function() {
        this.widiType = this.$refs.iosbtn.checked;
        this.widiTypeImg = this.$refs.iosbtn.checked
          ? "process-robot-animated.gif"
          : "process-human-animated.gif";
      });
    },
    // 跳转提交页面
    goRegister() {
      this.$router.push({ path: "Register" });
    },
    // 切换welcome图片
    changeImg(index) {
      if (this.welcome_timer || this.welcomeData.selectItem === index) {
        return;
      }
      const that = this;
      this.welcomeData.selectItem = index;
      this.$refs.welcome_list_box.style.transition = "left .8s";
      this.$refs.welcome_list_box.style.left =
        this.screenWidth > 768 ? "-797px" : -(this.screenWidth - 40) + 'px'
      this.welcomeData.leftItem[1].img_src = "welcome" + (index + 1) + ".jpg";
      this.welcomeData.leftItem[1].src = "hk" + (index + 1) + ".png";
      this.welcome_timer = setTimeout(function() {
        that.welcomeData.leftItem[0].img_src = "welcome" + (index + 1) + ".jpg";
        that.welcomeData.leftItem[0].src = "hk" + (index + 1) + ".png";
        that.$refs.welcome_list_box.style.transition = "none";
        that.$refs.welcome_list_box.style.left = "0px";
        that.welcome_timer = null;
      }, 800);
    },
    // 判断窗口大小
    resizeWindow() {
      // window.screenWidth = document.body.clientWidth;
      this.screenWidth = document.body.clientWidth;
      if (document.body.clientWidth < 768) {
        for (const key in this.$refs.welcome_img_item) {
          this.$refs.welcome_img_item[key].style.width = this.screenWidth - 40 + 'px'
        }
      }else{
        for (const key in this.$refs.welcome_img_item) {
          this.$refs.welcome_img_item[key].style.width = '797px';
        }
      }
    }
  },
  computed: {
    homeData() {
      return this.screenWidth > 768 ? this.lgHomeData : this.xsHomeData;
    }
  },
  mounted() {
    // 监听页面大小
    this.resizeWindow()
    window.addEventListener("resize", () => this.resizeWindow());
  },
  destroyed() {
    // 销毁监听页面大小事件
    window.removeEventListener("resize", this.resizeWindow(), true);
  }
};
</script>

<style lang="scss" scoped>
$green: #23bd8b;
$button-width: 60px;
$button-height: 30px;
$toggle-diameter: 20px;
$button-toggle-offset: ($button-height - $toggle-diameter) / 2;
$toggle-shadow-offset: 10px;
$toggle-wider: 30px;
.banner {
  display: flex;
  max-width: 970px;
  margin: 0 auto;
  padding: 90px 0 0 20px;
  align-items: center;
  .left-con {
    width: 52%;
    .icon{
      width: 20px;
      height: 20px;
      position: relative;
      bottom: -3px;
      margin-right: 10px;
    }
    .tit {
      font-size: 48px;
      line-height: 48px;
      letter-spacing: -3px;
      // width: 75%;
    }
    .tit1 {
      font-size: 40px;
      line-height: 40px;
      letter-spacing: -3px;
      // width: 75%;
    }
    .tit2{
      margin-bottom: 20px;
    }
    .con {
      font-size: 18px;
      color: #606060;
      font-weight: 400;
      margin: 36px 0 28px;
      line-height: 24px;
    }
    .btn {
      background: $green;
      width: 230px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      border-radius: 3px;
      color: #fff;
      font-size: 15px;
      cursor: pointer;
      font-family: "Medium";
    }
    @media screen and (max-width: 768px) {
      width: 100%;
      text-align: center;
      .btn {
        margin: 0 auto;
      }
      .tit {
        font-size: 30px;
      }
    }
  }
  .right-pic {
    width: 48%;
    @media screen and (max-width: 768px) {
      width: 90%;
      margin: 20px auto;
    }
    img {
      width: 100%;
    }
  }
}
.welcome {
  // max-width: 940px;
  max-width: 1080px;
  margin: 0 auto;
  padding: 70px 20px 0;
  text-align: center;
  .item-logo {
    width: 30px;
  }
  .tit {
    width: 35%;
    margin: 0 auto;
    font-size: 36px;
    line-height: 42px;
    letter-spacing: -2px;
  }
  .tit1 {
    width: auto;
  }
  .txt{
    text-align: left;
    margin:20px 0;
  }
  .con {
    width: 40%;
    margin: 32px auto 56px;
    font-size: 16px;
    line-height: 24px;
    color: rgba(35, 31, 32, 0.8);
  }
  .con1 {
    width: 40%;
    margin: 32px auto 20px;
    font-size: 16px;
    line-height: 24px;
    color: rgba(35, 31, 32, 0.8);
  }
  .welcome-top-container {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 4%;
    .welcome-item-left {
      max-width: 220px;
      .left-item {
        min-width: 40px;
        min-height: 40px;
        display: inline-block;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        padding-right: 10px;
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 10px;
        cursor: pointer;
        border: 1px solid transparent;
        .item-logo {
          padding: 20px;
        }
        .con {
          width: 65%;
          margin: 0;
          text-align: left;
          font-size: 16px;
          color: rgba(35, 31, 32, 0.8);
          font-family: "InterSemiBold";
        }
      }
      .active {
        background: white;
        border: 1px solid rgba(235, 239, 241, 1);
        border-radius: 2px;
        box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.05);
      }
    }
    .welcome-item-right {
      width: 74%;
      position: relative;
      margin-left: 20px;
      .tit {
        display: none;
        letter-spacing: 0px;
      }
      .tit1 {
        display: none;
        letter-spacing: 0px;
        }
      .img-container {
        overflow: hidden;
        position: relative;
        height: 100%;
        max-height: 470px;
        max-width: 797px;
        .list-box {
          width: 3900px;
          left: 0px;
          position: absolute;
          .img-item {
            float: left;
            width: 660px;
            & img {
              width: 100%;
            }
          }
        }
      }
      .dots {
        height: 170px;
        width: 65px;
        background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAACqCAYAAADydCIEAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QjEwQjZGQjdBQjBBMTFFQThBRUNGMDM0ODgyRTM1QUUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QjEwQjZGQjhBQjBBMTFFQThBRUNGMDM0ODgyRTM1QUUiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpCMTBCNkZCNUFCMEExMUVBOEFFQ0YwMzQ4ODJFMzVBRSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpCMTBCNkZCNkFCMEExMUVBOEFFQ0YwMzQ4ODJFMzVBRSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PgyxwCMAAAGVSURBVHja7NkxrgFRFIDhS6OxBvtQSuzDJCzLSlCosA61gohG5UwyhSjkyoRkru8m9/FenCm+RE7+vN7pfBmllJZxx3H3cRdxjynvFDHbC4R1vJk+fWgbd5L5wCJma4RrvBk+/fEed5D5wCJm+/Hj8PKhXco/RczWCPO4m7i35rX64IFFzNZfh/TvBwIECBAgQIAAAcKb02/SctWExar5PfcUMSulpbSUltJS2oqEAAECBAgQIECQ0lJaSktpKS2lrUgIECBAgAABAgQpLaWltJSW0lLaioQAAQIECBAgQJDSUlpKS2kpLaWtSAgQIECAAAECBCktpaW0lC4upWctsrSTs7aDFQkBAgQIECBAgCClpbSUltJSWkpbkRAgQIAAAQIECFJaSktpKf3DlK5aZGknZ20HKxICBAgQIECAAEFKS2kpLaXbpbT/SluRECBAgAABAgQIEKS0lJbSUlpKS2krEgIECBAgQIAAQUpLaSktpb+X0lWLLO3krO1gRUKAAAECBAgQIEhpKS2lpbSU/mj2IcAASygjXDuEzSMAAAAASUVORK5CYII=)
          no-repeat;
        position: absolute;
        top: -75px;
        right: -32px;
        z-index: -1;
      }
    }
  }
  .welcome-bottom-container {
    display: flex;
    flex-wrap: wrap;
    .bottom-item,
    .swiper-wrap {
      width: 33%;
      text-align: left;
      margin-bottom: 30px;
      .tit {
        width: auto;
        font-size: 18px;
        font-weight: 600;
        padding: 23px 0 25px;
        line-height: unset;
        letter-spacing: 0;
        font-family: "InterSemiBold";
      }
      .con {
        width: auto;
        max-width: 300px;
        margin: 0;
        line-height: 24px;
        padding-right: 20px;
        color: rgba(35, 31, 32, 0.8);
      }
    }
    .swiper-wrap {
      width: 100%;
      display: none;
    }
  }

  @media screen and (max-width: 768px) {
    padding-top: 0;
    .tit {
      width: auto;
      font-size: 30px;
      line-height: 30px;
    }
    .con {
      width: auto;
      margin: 23px auto 26px;
    }
    .welcome-top-container {
      margin: 0;
      .welcome-item-left {
        display: flex;
        padding: 0;
        justify-content: space-evenly;
        width: 100%;
        max-width: unset;
        .left-item {
          padding: 0;
          background: #ecf0f1;
          .item-logo {
            padding: 10px;
            font-size: 22px;
          }
          .con {
            display: none;
          }
        }
        .active {
          border-radius: 5px;
          background: white;
        }
      }
      .welcome-item-right {
        width: 100%;
        margin: 29px 0 0;
        .tit {
          display: block;
          font-size: 16px;
        }
        .img-container {
          height: 260px;
          margin-top: 26px;
          .list-box {
            .img-item {
              width: auto;
            }
          }
        }
      }
    }
    .welcome-bottom-container {
      margin-top: 70px;
      .bottom-item {
        display: none;
      }
      .swiper-wrap {
        display: block;
        margin: 0;
        padding-bottom: 30px;
      }
    }
  }
}
.automation {
  max-width: 940px;
  margin: 0 auto;
  padding: 55px 20px 0;
  text-align: center;
  .tit {
    width: 50%;
    margin: 0 auto;
    font-size: 30px;
    letter-spacing: -2px;
  }
  .con {
    margin: 32px auto 36px;
    font-size: 16px;
    color: rgba(35, 31, 32, 0.8);
  }
  .changeType {
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(35, 31, 32, 0.5);
    .changeType-btn {
      margin: 0 15px;
      display: inline-block;
      span {
        display: inline-block;
        width: $button-width;
        height: $button-height;
        background-color: $green;
        border-radius: $button-height / 2;
        position: relative;
        transition: 0.3s all ease-in-out;
        text-align: left;
        cursor: pointer;
      }

      span::after {
        content: "";
        width: $toggle-diameter;
        height: $toggle-diameter;
        background-color: #fff;
        border-radius: $toggle-diameter / 2;
        position: absolute;
        top: $button-toggle-offset;
        transform: translateX($button-toggle-offset);
        box-shadow: $toggle-shadow-offset 0 $toggle-shadow-offset * 4
          rgba(0, 0, 0, 0.1);
        transition: 0.3s all ease-in-out;
      }

      input[type="checkbox"]:checked + span {
        background-color: $green;
      }

      input[type="checkbox"]:checked + span::after {
        transform: translateX(
          $button-width - $toggle-diameter - $button-toggle-offset
        );
        box-shadow: $toggle-shadow-offset * -1 0 $toggle-shadow-offset * 4
          rgba(0, 0, 0, 0.1);
      }

      input[type="checkbox"] {
        display: none;
      }

      input[type="checkbox"]:active + span::after {
        width: $toggle-wider;
      }

      input[type="checkbox"]:checked:active + span::after {
        transform: translateX(
          $button-width - $toggle-wider - $button-toggle-offset
        );
      }
    }
    .active {
      color: rgba(35, 31, 32, 1);
    }
  }
  .automation-widi-container {
    display: flex;
    justify-content: space-between;
    margin-top: 60px;
    & > div {
      display: flex;
      margin-right: 20px;
    }
    .left-item-container {
      flex-direction: column;
      width: 15%;
      & > img {
        margin: 10px 15px;
        max-width: 110px;
      }
    }
    .mid-item-container {
      align-items: center;
      width: 40%;
      & > img:nth-child(2) {
        margin: 0 20px;
      }
    }
    .right-item-container {
      flex-wrap: wrap;
      width: 40%;
      .right-item {
        display: flex;
        align-items: center;
        text-align: left;
        height: 25%;
        & img {
          margin: 0 20px;
          max-width: 60px;
          max-height: 60px;
        }
        .widiImg {
          border: solid 2px #bec2c5;
          border-radius: 7px;
          width: 60px;
          padding: 8px;
          box-sizing: border-box;
        }
        .content {
          height: 100%;
          max-height: 90px;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .tit {
            font-size: 18px;
            line-height: 24px;
            font-weight: 600;
            width: 95%;
            margin: 0;
            letter-spacing: 0px;
            font-family: "InterSemiBold";
          }
          .con {
            margin: 0;
            line-height: 22px;
            color: rgba(35, 31, 32, 0.8);
          }
        }
      }
    }
  }
}
.bottom-bg {
  display: none;
  margin-top: 70px;
  .bottom-tit{
    font-size: 30px;
    font-family: 'InterBold';
    text-align: center;
    letter-spacing: -1px
  }
  .bottom-tip{
    text-align: center;
    margin-top: 30px;
    margin-bottom: 50px;
  }
  .bottom-banner {
    max-width: 940px;
    margin: 0 auto;   
    box-sizing: border-box;
    text-align: left;
    position: relative;
    color: white;
    display: flex;
    .line{
      width: 90px;
      border-bottom:3px solid #DC4274;
      -webkit-transform: rotate(155deg);/*Safari 4+,Google Chrome 1+  */
      -moz-transform: rotate(155deg);/*Firefox 3.5+*/
      transform:rotate(155deg);
      filter: progid:DXImageTransform.Microsoft.BasicImage(Rotation=0.15);
      position: relative;
      top: 30px;
      z-index: 3;
    }
    .sale{
      width: 80px;
      height: 30px;
      padding-left:10px ;
      line-height: 30px;
      background: #DC4274;
      font-size: 18px;
      color: #FFFFFF;
      position: absolute;
      right: -10px;
      top: 50px;
      z-index: 2;
    }
    .sale1{
    width:0;
    height:0;
    overflow:hidden;
    position: absolute;
    right: -10px;
    top: 80px;
    font-size: 0;     /*是因为, 虽然宽高度为0, 但在IE6下会具有默认的 */
    line-height: 0;  /* 字体大小和行高, 导致盒子呈现被撑开的长矩形 */
    border-width:10px 10px 0 0;
    border-style:solid;
    border-color:#DC4274 #FFFFFF transparent transparent; 
    }
    .free{
      // margin:30px 0;
      font-size: 50px;
      line-height: 60px;
      color: #DC4274;
    }
    .price{
      font-size: 50px;
      font-weight: bold;
      line-height: 60px;
      color: #FFFFFF;
      .price1{
        margin-right: 10px;
        opacity: 50%;
        filter:alpha(opacity=50);   
        -moz-opacity:0.5;   
        -khtml-opacity: 0.5;   
        opacity: 0.5;  
      }
    }
    .left-part,.right-part{
      width: 50%;
      padding: 30px 10%;
      .detail-tank{
        display: flex;
        margin: 10px 0;
        .el-icon-check{
          margin-right: 10px;
          color: $green;
          margin-top: 3px;
        }
      }
      &:hover{
        transform: scale(1.07);
      }
    }
    .left-part{
      background: #fff;
      border: 1px solid #cecccc;
      color: #111;
      .btn{
        background: $green;
        color: #fff
      }
    }
    .right-part{
      background: $green;
      .detail-tank{
        .el-icon-check{
          color: #fff
        }
      }
    }
    .dots {
      height: 170px;
      width: 65px;
      background: url("../assets/imgs/Icons/dots-1x.png") no-repeat;
      position: absolute;
      left: -30px;
      top: -30px;
      z-index: -1;
    }
    .tips{
      font-family: 'InterBold';
      width: 260px;
      font-size: 28px;
    }
    .tit {
      font-size: 50px;
      margin-top: 12px;
      .dollar{
        font-size: 34px;
        position: relative;
        top: -10px;
      }
    }
    .con {
      margin: 12px auto 12px;
    }
    .btn {
      width: 100%;
      line-height: 50px;
      background: #231f20;
      border-radius: 2px 3px 3px 2px;
      font-size: 15px;
      font-weight: 500;
      cursor: pointer;
      font-family: "Medium";
      text-align: center;
      margin: 24px 0;
    }
  }
  .sign-tip{
    text-align: center;
    margin-top: 60px;
    padding: 0 20px;
    .signup{
      cursor: pointer;
      color: $green;
      font-weight: bold;
    }
  }
  @media screen and (max-width: 768px) {
    margin-top: 30px;
    .bottom-tit{
      font-size: 22px
    }
    .bottom-tip{
      margin-bottom: 30px;
      margin-top: 20px;
    }
    .bottom-banner {
      width: 88%;
      padding: 0;
      flex-wrap: wrap;
      .sale{
      width: 80px;
      height: 30px;
      padding-left:10px ;
      line-height: 30px;
      background: #DC4274;
      font-size: 18px;
      color: #FFFFFF;
      position: absolute;
      right: -10px;
      top: 680px;
      z-index: 2;
      }
      .sale1{
      width:0;
      height:0;
      overflow:hidden;
      position: absolute;
      right: -10px;
      top: 710px;
      font-size: 0;     /*是因为, 虽然宽高度为0, 但在IE6下会具有默认的 */
      line-height: 0;  /* 字体大小和行高, 导致盒子呈现被撑开的长矩形 */
      border-width:10px 10px 0 0;
      border-style:solid;
      border-color:#DC4274 #FFFFFF transparent transparent; 
      }
      .left-part,.right-part{
        width: 100%;
      }
      .tit {
        font-size: 40px;
        margin-top: 10px;
        .dollar{
          top: -10px;
          font-size: 26px
        }
      }
      .con {
        margin: 10px 0;
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  .dots {
    display: none;
  }
  .welcome {
    padding-top: 0;
    .tit {
      width: auto;
      font-size: 30px;
      line-height: 30px;
    }
    .tit1 {
      width: auto;
      font-size: 30px;
      line-height: 30px;
    }
    .con {
      width: auto;
      margin: 23px auto 26px;
    }
    .con1 {
      width: auto;
      margin: 23px auto 0px;
    }
    .welcome-top-container {
      margin: 0;
      .welcome-item-left {
        display: flex;
        padding: 0;
        justify-content: space-evenly;
        width: 100%;
        max-width: unset;
        .left-item {
          padding: 0;
          background: #ecf0f1;
          .item-logo {
            padding: 10px;
            font-size: 22px;
          }
          .con {
            display: none;
          }
        }
        .active {
          border-radius: 5px;
          background: white;
        }
      }
      .welcome-item-right {
        width: 100%;
        margin: 29px 0 0;
        .tit {
          display: block;
          font-size: 16px;
        }
        .img-show {
          margin-top: 26px;
          & > div > img {
            width: 93%;
          }
          & > div:last-child {
            left: 20px;
            top: 31px;
            max-height: 50vw;
          }
        }
      }
    }
    .welcome-bottom-container {
      margin-top: 70px;
      .bottom-item {
        display: none;
      }
      .swiper-wrap {
        display: block;
        margin: 0;
        padding-bottom: 30px;
      }
    }
  }
  .automation {
    .tit {
      width: auto;
      font-size: 30px;
      line-height: 30px;
    }
    .con {
      margin: 22px auto 26px;
    }
    .automation-widi-container {
      margin-top: 40px;
      flex-wrap: wrap;
      & > div {
        width: 100% !important;
        margin-right: 0;
      }
      .left-item-container {
        & > img {
          width: 80px;
          height: 80px;
          margin: 0;
        }
        flex-direction: unset;
        justify-content: space-around;
      }
      .mid-item-container {
        flex-direction: column;
        & > img:first-child,
        :last-child {
          transform: rotate(90deg);
        }
        & > img:last-child {
          margin: 30px 0;
        }
      }
      .right-item-container {
        .right-item {
          align-items: unset;
          margin-bottom: 25px;
          height: unset;
          width: 100%;
          .img-item {
            & > img {
              margin: 0;
              width: 40px;
              padding: 14px 7px;
              border-radius: 10px;
            }
          }
          .widiImg {
            box-sizing: unset;
          }
          .content {
            margin-left: 10px;
            max-height: 92px;
            .tit {
              font-size: 17px;
              width: 100%;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .dots {
    display: none;
  }
  .banner {
    flex-wrap: wrap;
    padding: 40px 20px 0;
    .left-con {
      .tit {
        line-height: 30px;
        width: auto;
      }
      .tit1 {
        line-height: 30px;
        width: auto;
      }
      .tit2{
        margin-bottom: 20px;
      }
      .con {
        margin: 28px 0 26px;
      }
      .btn {
        width: 93%;
      }
    }
    .right-pic {
      width: 100%;
      margin: 40px 0 60px;
    }
  }
  .automation {
    .tit {
      width: auto;
      font-size: 30px;
      line-height: 30px;
    }
    .con {
      margin: 22px auto 26px;
    }
    .automation-widi-container {
      margin-top: 40px;
      flex-wrap: wrap;
      & > div {
        width: 100% !important;
        margin-right: 0;
      }
      .left-item-container {
        & > img {
          width: 80px;
          height: 80px;
          margin: 0;
        }
        flex-direction: unset;
        justify-content: space-between;
      }
      .mid-item-container {
        flex-direction: column;
        & > img:first-child,
        :last-child {
          transform: rotate(90deg);
        }
        & > img:last-child {
          margin: 30px 0;
        }
      }
      .right-item-container {
        .right-item {
          align-items: unset;
          margin-bottom: 25px;
          height: unset;
          .img-item {
            & > img {
              margin: 0;
              width: 40px;
              padding: 14px 7px;
              border-radius: 10px;
            }
          }
          .widiImg {
            box-sizing: unset;
          }
          .content {
            margin-left: 10px;
            max-height: 92px;
            .tit {
              font-size: 17px;
              width: 100%;
            }
          }
        }
      }
    }
  }
}

.animated {
  -webkit-animation-duration: 0.8s;
  animation-duration: 0.8s;
}
</style>

<style lang="scss">
.swiper-container-horizontal
  > .swiper-pagination-bullets
  .swiper-pagination-bullet {
  background: #bdc3c7;
  margin: 0 10px;
}
.swiper-container-horizontal
  > .swiper-pagination-bullets
  .swiper-pagination-bullet-active {
  background: #23bd8b;
}
</style>
